module.exports = __webpack_public_path__ + "images/emoji/package.2b8ecb27a48c41a34e80.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/package.png
// module id = THM/
// module chunks = 13